/* eslint-disable no-console */
import { mapContractToERP } from '@/js/mappers/contract';
import ContractRepository from '@/js/repositories/contractRepository';
import FieldRepository from '@/js/repositories/fieldRepository';
import {
  removeContract,
  saveContract,
} from '@/js/services/contracts/ApiContractsWs';

export default {
  async add(object) {
    await ContractRepository.add(object);
    return object;
  },

  async updateById(id, objeto) {
    return ContractRepository.updateById(id, objeto);
  },

  async deleteById(id) {
    const contract = await this.getById(id);
    if (!contract.id_external || contract.id_external <= 0) {
      return ContractRepository.deleteById(id);
    }
    contract.sync_status = 2;
    return this.updateById(id, contract);
  },

  async getById(id) {
    return ContractRepository.getById(id);
  },

  async getAll() {
    return ContractRepository.getAll();
  },

  async getContractsByFarmer(farmerId) {
    return ContractRepository.getContractsByFarmer(farmerId);
  },

  async getContractsByField(fieldId) {
    return ContractRepository.getContractsByField(fieldId);
  },

  async getAllSyncPending() {
    const contracts = await ContractRepository.getAllSyncPending();
    for await (const contract of contracts) {
      const field = await FieldRepository.getByIdFull(contract.field.id);
      [contract.field] = field;
    }

    return contracts;
  },

  async saveContractToERP(contract) {
    const contractERP = mapContractToERP(contract);
    await saveContract(contractERP).then(async (response) => {
      console.log('se recibe llamada del guardar');
      if (response.data.Valor) {
        const responseObject = response.data.Tag;
        await this.updateById(contract.id, { sync_status: 0, id_external: responseObject.Id, sync_error_msg: '' });
      } else {
        console.log('ERROR sync CONTRATO', contract, response.data.Mensaje);
        await this.updateById(contract.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error sync contrato', contract, error);
      await this.updateById(contract.id, { sync_error_msg: error });
    });
  },

  async removeContractFromERP(contract) {
    return removeContract(contract).then(async (response) => {
      if (response.data.Valor) {
        await ContractRepository.deleteById(contract.id);
      } else {
        console.log('ERROR sync CONTRATO', contract, response.data.Mensaje);
      }
    }).catch((error) => {
      console.log('error sync contrato', contract, error);
    });
  },

  async syncPendingContracts() {
    const syncContracts = await this.getAllSyncPending();
    const promises = syncContracts.map(async (contract) => {
      try {
        if (contract.sync_status === 1) {
          await this.saveContractToERP(contract);
        } else if (contract.sync_status === 2) {
          await this.removeContractFromERP(contract);
        }
      } catch (error) {
        console.error('Error en syncPendingContracts:', error);
      }
    });

    await Promise.all(promises);
    /* syncContracts.forEach(async (contract) => {
      if (contract.sync_status === 1) await this.saveContractToERP(contract);
      else if (contract.sync_status === 2) await this.removeContractFromERP(contract);
    }); */
  },

  async getAllPrimaryKeys() {
    const contracts = await this.getAll();
    return contracts.map((f) => f.id_external || 0);
  },
};
